import { memo, useMemo } from "react";
import { Outlet, useLocation } from "react-router";
import clsx from "clsx";

import { PAGE_LAYOUT_ID } from "@/features/notes/config";
import { RouteAnimation } from "../ui/RouteAnimation";
import { useBoundStore } from "@/app/store";
import { LAYOUT } from "@/config/constants";

function MainMobileComponent() {
  const className = useBoundStore((state) => state.pageLayout.className);
  const fab = useBoundStore((state) => state.pageLayout.fab);
  const onScroll = useBoundStore((state) => state.pageLayout.onScroll);
  const animationKey = useBoundStore((state) => state.pageLayout.animationKey);
  const showBottomNavigation = useBoundStore((state) => state.pageLayout.showBottomNavigation);
  const location = useLocation();
  const finalAnimationKey = animationKey || location.pathname;

  const style = useMemo(
    () => ({
      paddingTop: "calc(2px + var(--inset-top))",
      paddingRight: "calc(16px + var(--inset-right))",
      paddingLeft: "calc(16px + var(--inset-left))",
      paddingBottom: showBottomNavigation ? LAYOUT.mobile.bottomPadding : "calc(8px + var(--inset-bottom))",
    }),
    [showBottomNavigation]
  );

  return (
    <RouteAnimation
      animationKey={finalAnimationKey}
      id={PAGE_LAYOUT_ID}
      className={clsx("relative h-full flex-1 overflow-y-auto p-4 pt-0.5", className, { "pb-16": Boolean(fab) })}
      onScroll={onScroll}
      style={style}
    >
      <Outlet />
    </RouteAnimation>
  );
}

export const MainMobile = memo(MainMobileComponent);
